import { XClose } from '@kula-ai/icons/outline/XClose';
import { Flex, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';

export const SelectMultiValueItem = ({
  clearValue,
  children,
  parentStyle,
  labelStyle,
  iconStyle,
}) => {
  return (
    <Flex
      p=".35em"
      m=".25em .5em"
      gap=".25em"
      border="1px solid #C4C4C5"
      borderRadius="6px"
      alignItems="center"
      {...parentStyle}
    >
      <KText {...labelStyle}>{children}</KText>
      <Icon
        _hover={{ color: 'red' }}
        {...iconStyle}
        as={XClose}
        onClick={clearValue}
        cursor="pointer"
      />
    </Flex>
  );
};
